import axios from 'axios';
import Vue from 'vue';
import GrooveUIKitV2 from '../../groove-ui-kit-v2/src/vue2/groove-ui-kit';
import '../../groove-ui-kit-v2/src/styles/groove-ui-kit.css';
import '../../groove-ui-kit-v2/src/styles/refresh-controls.css';

Vue.use(GrooveUIKitV2);
import PortalVue from 'portal-vue';
import { ServerTable, ClientTable } from 'vue-tables-2';
import iFrameResize from 'iframe-resizer/js/iframeResizer';
import VueQRCodeComponent from 'vue-qrcode-component';
import VueClipboard from 'vue-clipboard2';
import VueSweetalert2 from 'vue-sweetalert2';
import { VTooltip } from 'v-tooltip';
import VSelect from 'vue-select';
import App from './components/App';
import VueYoutube from 'vue-youtube';
import VueFragment from 'vue-fragment';
import store from './state';
import router from './router';
import wait from './plugins/wait';
import config from '../../load-config';
import i18n from './plugins/i18n';
import keycloakAuth from './services/keycloakAuth';
import { isFreeAccountRestricted } from '../../shared/accountAccess';
import { resumeStoredAppRedirect } from './router/resume-app-redirect';
import './plugins';
import './components';
import 'vue-select/dist/vue-select.css';
import '@groovepages/gd-ui-kit/styles.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('lang');
if (lang) localStorage.setItem('lang', lang);

config.then(async configValues => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}`;
  let appFrontendURL = configValues.VUE_APP_FRONTEND_URL;

  if (configValues.VUE_APP_FRONTEND_URL.includes('/groovepages')) {
    appFrontendURL = configValues.VUE_APP_FRONTEND_URL.replace(
      '/groovepages',
      ''
    );
  }

  // keycloakAuth.init() reads window.gdEnv?.VUE_APP_KEYCLOAK_* at construction
  // time. Assign ConfigMap/runtime values before init or the hardcoded fallback
  // IdP URL is used and ConfigMap overrides are ignored.
  window.gdEnv = configValues;

  // Initialize Keycloak early
  try {
    await keycloakAuth.init();
    console.log('Keycloak initialized');
  } catch (error) {
    console.error('Failed to initialize Keycloak:', error);
  }

  const localConfig = {
    apiUrl: `${configValues.VUE_APP_API_URL}`,
    appUrl: `${configValues.VUE_APP_GROOVEVIDEO_URL}`,
    grooveappsurl: appFrontendURL,
    apiCoreUrl: `${configValues.VUE_APP_API_URL}/groovedigital`
  };
  window.config = localConfig;

  // The identity provider returns to this origin. Reopen the GrooveSell page
  // that sent the person to sign in instead of leaving them on the dashboard.
  // A failed Groove profile must stay on this page. Leaving for a stored app
  // URL here unloads the document before the sign-in error can render.
  if (keycloakAuth.isAuthenticated() && !keycloakAuth.loginFailure) {
    try {
      const nextUrl = resumeStoredAppRedirect({
        redirect: localStorage.getItem('redirect'),
        origin: window.location.origin,
        pathname: window.location.pathname,
        hash: window.location.hash,
        restricted: isFreeAccountRestricted()
      });
      if (nextUrl) {
        localStorage.removeItem('redirect');
        window.location.replace(nextUrl);
        return;
      }
    } catch (error) {
      console.error('Failed to resume the Groove app the person was using:', error);
    }
  }

  Vue.config.productionTip = false;

  Vue.directive('resize', {
    bind(el, { value = {} }) {
      el.addEventListener('load', () => iFrameResize(value, el));
    }
  });

  Vue.use(VueYoutube);
  Vue.use(VueFragment.Plugin);
  Vue.use(PortalVue);
  Vue.use(ClientTable);
  Vue.use(ServerTable);
  Vue.use(VueClipboard);
  Vue.use(VueSweetalert2);
  Vue.component('v-select', VSelect);
  Vue.component('qr-code', VueQRCodeComponent);
  Vue.directive('tooltip', VTooltip);

  Vue.filter(

  )

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
    store,
    router,
    wait,
    ...App
  });
});
